import React, { useCallback, useEffect, useMemo, useState } from "react";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";


import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  Paper as MuiPaper,
  Typography,
  Button,
  CircularProgress,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Dialog,
  CardContent,
  Card,
  TextField,
  InputLabel,
  Input,
  Checkbox,
  LinearProgress,
  FormControl,
  Select,
  MenuItem,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  ListSubheader,
  Popper,
  Autocomplete,
  InputAdornment,
  TextareaAutosize,
} from "@mui/material";
import { Box, spacing } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import Grid from "@mui/system/Unstable_Grid";

import { useNavigate } from "react-router-dom";
import { formatarCodTribNac, formatCNAE } from "../../../utils/infoUtils";

function AddNewCatalog(props) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();

  const { onClose, open, allowCatalogType } = props;
  const handleClose = (e = null) => {
    onClose(e);
  };
  let [catalogTypeList, setCatalogTypeList] = useState([]);
  let [cnaeList, setCnaeList] = useState([]);
  let [cnaeMineList, setCnaeMineList] = useState([]);
  let [tribISSQNTypeList, setTribISSQNTypeList] = useState([]);
  let [retentionISSQNTypeList, setRetentionISSQNTypeList] = useState([]);
  let [immunityISSQNTypeList, setImmunityISSQNTypeList] = useState([]);
  let [codTribNacionalList, setCodTribNacionalList] = useState([]);

  let [catalogType, setCatalogType] = useState(2);
  let [cnaeId, setCnaeId] = useState();
  let [showcnaeMine, setShowCnaeMine] = useState(true);
  let [tribISSQNTypeId, setTribISSQNTypeId] = useState(1);
  let [retentationISSQNTypeId, setRetentionISSQNTypeId] = useState(1);
  let [immunityISSQNTypeId, setImmunityISSQNTypeId] = useState(null);
  let [priceItem, setPriceItem] = useState(0);
  let [aliqISSQN, setAliqISSQN] = useState(5);
  let [itemName, setItemName] = useState(null);
  let [codTribNacionalId, setCodTribNacionalId] = useState(null);

  let [saving, setSaving] = useState(false);
  let [errormsg, setErrorMsg] = useState("");

  let [dsNFse, setDsNFse] = useState(null);

  const loadCodTribNacional = useCallback(async () => {
    const response = await getApi("/nf/cod_trib_nac/list");
    if (!response) {
      return;
    }
    setCodTribNacionalList(response);
  }, [getApi]);

  const loadTribISSQNType = useCallback(async () => {
    const response = await getApi("/nf/trib_issqn_type/list");
    if (!response) {
      return;
    }
    setTribISSQNTypeList(response.lista);
  }, [getApi]);

  const loadCatalogTypeList = useCallback(async () => {
    const response = await getApi("/catalog/type/list");
    if (!response) {
      return;
    }
    setCatalogTypeList(response.lista);
  }, [getApi]);

  const loadCNAEs = useCallback(async () => {
    const response = await getApi("/nf/cnae/list");
    if (!response) {
      return;
    }
    setCnaeList(response);
  }, [getApi]);

  const loadCNAEMine = useCallback(async () => {
    const response = await getApi("/business-account/cnae/list");
    if (!response) {
      return;
    }
    setCnaeMineList(response.lista);
  }, [getApi]);

  const loadRetentionISSQNType = useCallback(async () => {
    const response = await getApi("/nf/retention_issqn_type/list");
    if (!response) {
      return;
    }
    setRetentionISSQNTypeList(response.lista);
  }, [getApi]);

  const loadImmunityISSQNType = useCallback(async () => {
    const response = await getApi("/nf/immunity_issqn_type/list");
    if (!response) {
      return;
    }
    setImmunityISSQNTypeList(response.lista);
  }, [getApi]);

  useEffect(() => {
    if (open) {
      //   loadCNAEs();
      loadCatalogTypeList();
      // loadCNAEMine();
      loadTribISSQNType();
      loadCodTribNacional();
      loadRetentionISSQNType();
      loadImmunityISSQNType();
    }
  }, [open]);

  const handleSubmit = async () => {
    setSaving(true);
    setErrorMsg("");

    if (!checkValues()) {
      setSaving(false);
      setErrorMsg("");
      return false;
    }

    const response = await postApi("/catalog/create", {
      catalog_type_id: catalogType,
      name: itemName,
      price: priceItem ? priceItem : 0,

      nfs: {
        trib_issqn_type_id: tribISSQNTypeId,
        cod_trib_nac: codTribNacionalId,
        aliq_iss: aliqISSQN
          ? parseFloat(String(aliqISSQN).replace(",", ".")).toFixed(2)
          : 0.0,
        retention_issqn_type_id: retentationISSQNTypeId,
        immunity_issqn_type_id: tribISSQNTypeId == 2 ? immunityISSQNTypeId : 0,
        description_nfse: dsNFse,
      },
    });
    if (!response) {
      return;
    }
    response_run(response);
  };

  const response_run = (response) => {
    if (response.catalog) {
      alert("Catálogo cadastrado com sucesso.");

      handleClose();
      window.location.reload(false);
    } else {
      if (response.catalog_type_id) {
        setErrorMsg(response.catalog_type_id.toString());
      } else if (response.name) {
        setErrorMsg(response.name.toString());
      } else if (response.price) {
        setErrorMsg(response.price.toString());
      } else if (response["nfs.trib_issqn_type_id"]) {
        setErrorMsg(response["nfs.trib_issqn_type_id"][0]);
      } else if (response["nfs.cod_trib_nac"]) {
        setErrorMsg(response["nfs.cod_trib_nac"][0]);
      } else if (response["nfs.aliq_iss"]) {
        setErrorMsg(response["nfs.aliq_iss"][0]);
      } else if (response["nfs.retention_issqn_type_id"]) {
        setErrorMsg(response["nfs.retention_issqn_type_id"][0]);
      } else if (response["nfs.immunity_issqn_type_id"]) {
        setErrorMsg(response["nfs.immunity_issqn_type_id"][0]);
      } else if (response["nfs.description_nfse"]) {
        setErrorMsg(response["nfs.description_nfse"][0]);
      } else if (response.message) {
        if (response.message == "This action is unauthorized.") {
          setErrorMsg("Você não possui permissão para isso");
        }
      } else {
        setErrorMsg(response.error);
      }
      setSaving(false);
    }
  };

  const checkValues = () => {
    if (!itemName) {
      alert("Você precisa preencher o nome do produto/serviço");
    } else if (!codTribNacionalId) {
      alert("Você precisa informar o código tributário");
    } else if (!dsNFse) {
      alert("Você precisa definir uma descrição da NFs-e");
    } else {
      return true;
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle id="simple-dialog-title">
        <center>Cadastre um produto/serviço</center>
      </DialogTitle>

      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Card mb={1}>
            <Grid container justifyContent="center">
              <Grid item></Grid>
            </Grid>

            <CardContent>
              <Grid container spacing={6}>
                <Grid item md={12}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      O que você venderá ?
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      defaultChecked={catalogType}
                      defaultValue={catalogType}
                    >
                      {catalogTypeList.length > 0 &&
                        catalogTypeList.map((el) => (
                          <FormControlLabel
                            value={el.id}
                            control={<Radio />}
                            label={el.name}
                            onClick={(e) =>
                              setCatalogType(
                                allowCatalogType.includes(el.id) != el.id
                                  ? 2
                                  : el.id
                              )
                            }
                            checked={catalogType == el.id}
                            disabled={!allowCatalogType.includes(el.id)}
                          />
                        ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={6}>
                <Grid item md={12}>
                  <FormControl fullWidth>
                    <TextField
                      label={
                        [2].includes(catalogType)
                          ? "Nome do serviço prestado"
                          : "Nome do produto vendido"
                      }
                      placeholder={
                        [2].includes(catalogType)
                          ? "Ex: Mensalidade escolar/internet/tracker"
                          : null
                      }
                      variant="outlined"
                      fullWidth
                      required
                      my={2}
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} mb={2}>
                <Grid item md={12}>
                  {codTribNacionalList.total && (
                    <CodTribNacionalAutocomplete
                      setCodTribNacionalId={setCodTribNacionalId}
                      codTribNacionalList={codTribNacionalList}
                    />
                  )}
                </Grid>
              </Grid>

              {cnaeList.total > 0 && (
                <Grid container spacing={6} mb={2}>
                  <Grid item md={12}>
                    <CNAEAutocomplete
                      cnaeList={cnaeList}
                      setCnaeId={setCnaeId}
                      cnaeId={cnaeId}
                      allowedIds={
                        showcnaeMine
                          ? cnaeMineList.map((item) => item.id)
                          : null
                      }
                      key={"CNAEAutocomplete" + showcnaeMine}
                    />

                    <FormControlLabel
                      checked={showcnaeMine}
                      onChange={(e) => {
                        setShowCnaeMine(!showcnaeMine);
                        setCnaeId(null);
                      }}
                      control={<Checkbox />}
                      label="Mostrar CNAEs apenas do meu CNPJ"
                    />
                  </Grid>
                </Grid>
              )}
              <Grid container spacing={6} mb={2}>
                <Grid item md={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Tributação do ISSQN
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Tributação do ISSQN"
                      value={tribISSQNTypeId}
                      required
                      onChange={(e) => setTribISSQNTypeId(e.target.value)}
                    >
                      {tribISSQNTypeList &&
                        tribISSQNTypeList.map((el) => (
                          <MenuItem value={el.id}>{el.name}</MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={6} mb={2}>
                <Grid item md={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Tipo de retencao do ISSQN
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Tipo de retencao do ISSQN"
                      required
                      value={retentationISSQNTypeId}
                      onChange={(e) => setRetentionISSQNTypeId(e.target.value)}
                    >
                      {retentionISSQNTypeList &&
                        retentionISSQNTypeList.map((el) => (
                          <MenuItem value={el.id}>{el.name}</MenuItem>
                        ))}
                    </Select>
                    <Typography
                      variant="caption"
                      display="flex"
                      alignItems="center"
                      gap={0.5}
                    >
                      Responsável pela retenção do ISS
                      <Tooltip
                        title={
                          <>
                            Indica quem será responsável por reter e recolher o
                            ISS.
                            <br />
                            Pode ser o prestador (não retido), o tomador ou o
                            intermediário do serviço.
                          </>
                        }
                      >
                        <HelpOutlineIcon
                          fontSize="small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
              {tribISSQNTypeId == 2 && (
                <Grid container spacing={6} mb={2}>
                  <Grid item md={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Identificação da Imunidade do ISSQN
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Identificação da Imunidade do ISSQN"
                        value={immunityISSQNTypeId}
                        required
                        onChange={(e) => setImmunityISSQNTypeId(e.target.value)}
                        sx={{
                          width: "100%",
                          maxWidth: 600,
                          fontSize: "0.875rem",
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxWidth: 600,
                              whiteSpace: "normal",
                            },
                          },
                        }}
                        PopperComponent={(props) => (
                          <Popper
                            {...props}
                            sx={{
                              maxWidth: 600,
                              "& .MuiPaper-root": { maxWidth: 600 },
                            }}
                            placement="bottom-start"
                          />
                        )}
                      >
                        {immunityISSQNTypeList &&
                          immunityISSQNTypeList.map(
                            (el) =>
                              el.id != 0 && (
                                <MenuItem
                                  key={el.id}
                                  value={el.id}
                                  sx={{
                                    whiteSpace: "normal", // Permite quebra de linha
                                    overflowWrap: "break-word", // Quebra palavras muito longas
                                    wordBreak: "break-word", // Quebra palavras em excesso
                                    display: "block", // Garante que o texto ocupe toda largura
                                    lineHeight: 1.3,
                                    paddingTop: 1,
                                    paddingBottom: 1,
                                    marginTop: 1,
                                  }}
                                >
                                  {el.name}
                                </MenuItem>
                              )
                          )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={6} mb={2}>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Valor do serviço"
                      placeholder={"Valor do serviço"}
                      variant="outlined"
                      fullWidth
                      required
                      my={2}
                      value={parseFloat(priceItem).toFixed(2)}
                      onChange={(x) => {
                        let val = String(x.target.value).replace(/\D/g, "");
                        setPriceItem(val / 100);
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">R$</InputAdornment>
                        ),
                        inputMode: "decimal",
                      }}
                    />

                    <Typography
                      variant="caption"
                      display="flex"
                      alignItems="center"
                    >
                      Valor padrão do produto ou serviço.
                      <Tooltip title="Esse valor pode ser alterado ao gerar a cobrança.">
                        <HelpOutlineIcon
                          fontSize="small"
                          style={{ marginLeft: 4, cursor: "pointer" }}
                        />
                      </Tooltip>
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Aliquota ISS"
                      placeholder={"Aliquota ISS"}
                      variant="outlined"
                      fullWidth
                      required
                      my={2}
                      value={parseFloat(aliqISSQN).toFixed(2)}
                      onChange={(x) => {
                        let val = String(x.target.value).replace(/\D/g, "");
                        setAliqISSQN(val / 100);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                        inputMode: "decimal",
                      }}
                    />
                    <Typography
                      variant="caption"
                      display="flex"
                      alignItems="center"
                      gap={0.5}
                    >
                      Alíquota aplicada na emissão da nota fiscal
                      <Tooltip title="Percentual usado para calcular os impostos na emissão da nota fiscal.">
                        <HelpOutlineIcon
                          fontSize="small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={6}>
                <Grid item md={12}>
                  <TextField
                    label="Descrição do item na Nfs"
                    variant="outlined"
                    id={"xdescNfs-input"}
                    minRows={3}
                    multiline
                    value={dsNFse}
                    onChange={(e) => setDsNFse(e.target.value)}
                    placeholder={
                      "Descrição da Nota Fiscal. Ex: Mensalidade da Internet"
                    }
                    fullWidth
                    required
                    style={{ minWidth: window.isNativeApp ? "100%" : "100%" }}
                  />
                  <Typography
                    variant="caption"
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                  >
                    Texto padrão para a nota fiscal
                    <Tooltip
                      title={
                        <>
                          Texto padrão que será exibido na nota fiscal.
                          <br />
                          Pode ser ajustado no momento da emissão da cobrança.
                        </>
                      }
                    >
                      <HelpOutlineIcon
                        fontSize="small"
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <br></br>
                    <small>{"Caracteres:"+String(dsNFse).length}</small>
                  </Typography>
                </Grid>
              </Grid>

              <Grid container justifyContent="center">
                <Grid item>
                  <Typography color="#df4759" variant="h7">
                    {errormsg}
                  </Typography>
                  {saving && (
                    <Box sx={{ display: "flex" }}>
                      <CircularProgress />
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="space-between"
                sx={{ marginTop: 5 }}
              >
                <Button
                  variant="contained"
                  onClick={handleClose}
                  disabled={saving}
                  color="boot_secondary"
                >
                  Fechar
                </Button>
                <Button
                  variant="contained"
                  disabled={saving}
                  color="primary"
                  mt={3}
                  sx={{ marginLeft: 3 }}
                  onClick={handleSubmit}
                >
                  Salvar informações
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export function CNAEAutocomplete({ cnaeList, setCnaeId, allowedIds }) {
  const cnaeOptions = useMemo(() => {
    const allowed = allowedIds ?? [];

    return Object.entries(cnaeList.categories).flatMap(([category, items]) =>
      items
        .filter((item) =>
          allowed.length > 0 ? allowed.includes(item.id) : true
        )
        .map((item) => ({
          ...item,
          label: `${item.name} (${item.cnae_code})`,
          group: category,
        }))
    );
  }, [cnaeList.categories, allowedIds]);

  if (cnaeList.length == 0) {
    return <React.Fragment></React.Fragment>;
  }

  function normalizeString(str) {
    if (typeof str !== "string") str = String(str ?? "");

    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/['’]/g, "")
      .toLowerCase();
  }

  return (
    <Autocomplete
      options={cnaeOptions}
      groupBy={(option) => option.group}
      getOptionLabel={(option) => option.label}
      onChange={(event, value) => setCnaeId(value?.id)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Buscar CNAE por nome ou código"
          variant="outlined"
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {option.name} ({formatCNAE(option.cnae_code)})
          </Typography>
        </li>
      )}
      filterOptions={(options, { inputValue }) => {
        const search = normalizeString(inputValue);
        return options.filter((opt) => {
          return (
            normalizeString(opt.name).includes(search) ||
            normalizeString(opt.cnae_code).includes(search)
          );
        });
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      PopperComponent={(props) => (
        <Popper {...props} sx={{ maxWidth: 600 }} placement="bottom-start" />
      )}
      sx={{ width: "100%", maxWidth: 600 }}
    />
  );
}

export function CodTribNacionalAutocomplete({
  codTribNacionalList,
  setCodTribNacionalId,
  allowedIds,
}) {
  const cnaeOptions = useMemo(() => {
    const allowed = allowedIds ?? [];

    return Object.entries(codTribNacionalList.categories).flatMap(
      ([category, items]) =>
        items
          .filter((item) =>
            allowed.length > 0 ? allowed.includes(item.id) : true
          )
          .map((item) => ({
            ...item,
            label: `${item.name} (${formatarCodTribNac(item.code)})`,
            group: category,
          }))
    );
  }, [codTribNacionalList.categories, allowedIds]);

  if (codTribNacionalList.length == 0) {
    return <React.Fragment></React.Fragment>;
  }

  function normalizeString(str) {
    if (typeof str !== "string") str = String(str ?? "");

    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/['’]/g, "")
      .toLowerCase();
  }

  return (
    <Autocomplete
      options={cnaeOptions}
      groupBy={(option) => option.group}
      getOptionLabel={(option) => option.label}
      onChange={(event, value) => setCodTribNacionalId(value?.id)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Buscar Código Tributário Nacional"
          variant="outlined"
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {option.name} ({formatarCodTribNac(option.code)})
          </Typography>
        </li>
      )}
      filterOptions={(options, { inputValue }) => {
        const search = normalizeString(inputValue);
        return options.filter((opt) => {
          return (
            normalizeString(opt.name).includes(search) ||
            normalizeString(opt.code).includes(search)
          );
        });
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      PopperComponent={(props) => (
        <Popper {...props} sx={{ maxWidth: 600 }} placement="bottom-start" />
      )}
      sx={{ width: "100%", maxWidth: 600 }}
      renderGroup={(params) => (
        <li key={params.key}>
          <Box
            sx={{
              position: "sticky",
              top: "-8px",
              padding: "4px 12px",
              backgroundColor: (theme) =>
                theme.palette.mode === "light"
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              zIndex: 1,
              fontWeight: "bold",
              color: (theme) => theme.palette.primary.dark,
              borderBottom: "2px solid",
              borderColor: (theme) => theme.palette.divider,
            }}
          >
            {/* Aqui você pode personalizar o texto do grupo */}
            {params.group.toUpperCase()}{" "}
            {/* Exemplo: transforma em maiúsculas */}
          </Box>
          <Box component="ul" sx={{ padding: 0 }}>
            {params.children}
          </Box>
        </li>
      )}
    />
  );
}

export default AddNewCatalog;
